import { useEffect, useState } from 'react'
import {
  Card,
  Button,
  Typography,
  Space,
  Skeleton,
  Row,
  Divider,
  Col
} from 'antd'
import {
  FaBed,
  FaCheckCircle,
  FaCopy,
  FaFacebook,
  FaTelegram,
  FaWhatsapp
} from 'react-icons/fa'
import { AiFillCar } from 'react-icons/ai'
import { BsArrowsMove } from 'react-icons/bs'
import Header from '../components/Header'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { getPropertiesByCode } from '../services/request'
import DOMPurify from 'dompurify'

// IMPORTS DO REACT-SLICK
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import RelatedProducts from '../components/RelatedProducts'
import Footer from '../components/Footer'

const { Title, Text } = Typography

export default function ProductDetails () {
  const [loading, setLoading] = useState(true)
  const [product, setProduct] = useState(null)

  const isMobile = window.innerWidth <= 768

  const whats =
    'https://wa.me/5522999666419?text=Ol%C3%A1,%0A%0AEstou%20interessado(a)%20em%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20os%20servi%C3%A7os%20oferecidos%20pela%20sua%20imobili%C3%A1ria.'
  const currentUrl = window.location.href
  const shareText = 'Confira este imóvel: '

  const shareLinks = {
    whatsapp: `https://wa.me/?text=${encodeURIComponent(
      shareText + ' ' + currentUrl
    )}`,
    telegram: `https://t.me/share/url?url=${encodeURIComponent(
      currentUrl
    )}&text=${encodeURIComponent(shareText)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      currentUrl
    )}`,
    instagram: 'https://www.instagram.com/'
  }

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const productCode = searchParams.get('code')

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [])

  useEffect(() => {
    const getProductById = async () => {
      setLoading(true)
      try {
        const foundProduct = await getPropertiesByCode(productCode)
        if (foundProduct) {
          console.log('Produto encontrado:', foundProduct)
          setProduct(foundProduct)
        }
      } catch (error) {
        console.error('Error fetching product:', error)
      } finally {
        setLoading(false)
      }
    }

    if (productCode) {
      getProductById()
    }
  }, [productCode])

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        alert('Link copiado para a área de transferência!')
      })
      .catch((err) => {
        console.error('Erro ao copiar link:', err)
      })
  }

  const host = process.env.REACT_APP_API_URL || 'http://localhost:3001'

  if (loading || !product) {
    return (
      <>
        <Header />
        <div style={{ maxWidth: 1200, margin: '20px auto', padding: 16 }}>
          <Card
            style={{
              borderRadius: 8,
              overflow: 'hidden',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
            }}
          >
            <Skeleton active />
            <Skeleton.Image style={{ height: 400, width: '100%' }} />
            <Skeleton active title={false} paragraph={{ rows: 3 }} />
          </Card>
        </div>
      </>
    )
  }

  const {
    local,
    images,
    // tipo,
    descricaoCompleta,
    descricao,
    valor,
    dormitorios,
    garagem,
    au,
    features
  } = product

  const sliderSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: 1,
    autoplay: true,
    draggable: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } }
    ]
  }

  const isHTML = (str) => {
    if (!str || typeof str !== 'string') return false

    const htmlRegex = /<\/?[a-z][\s\S]*>/i
    return htmlRegex.test(str)
  }

  return (
    <>
      <Header />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: 95
        }}
      >
        <div style={{ width: '100%' }}>
          <Slider {...sliderSettings}>
            {images && images.length > 0
              ? (
                images.map(({ id }) => (
                  <div key={id}>
                    <img
                      src={`${host}/products/image/${id}`}
                      alt="Imagem do imóvel"
                      style={{
                        width: '100%',
                        height: 400,
                        objectFit: 'cover',
                        padding: 5
                      }}
                    />
                  </div>
                ))
              )
              : (
                <div>
                  <img
                    src="/no-image.png"
                    alt="Sem imagem"
                    style={{
                      width: '100%',
                      height: 400,
                      objectFit: 'cover'
                    }}
                  />
                </div>
              )}
          </Slider>
        </div>

        <Row
          md={12}
          lg={6}
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 50,
            maxWidth: 1200,
            marginTop: 20
          }}
        >
          <div
            style={{
              marginRight: isMobile ? 0 : 30,
              padding: 10,
              maxWidth: 700
            }}
          >
            <Title
              level={isMobile ? 2 : 1}
              style={{ textAlign: 'left', margin: 0, padding: 0 }}
            >
              {local}
            </Title>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}
            >
              <Text style={{ textAlign: 'left' }}>{descricao}</Text>
              <Text type="secondary">Código do imóvel: {productCode}</Text>
            </div>
            <Divider style={{ padding: 2, marginTop: 10, marginBottom: 5 }} />

            <Row gutter={[16, 16]} style={{ padding: '10px 0', marginTop: 2 }}>
              {dormitorios > 0 && (
                <Col md={8} lg={6}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <FaBed /> Dormitórios: {dormitorios}
                  </div>
                </Col>
              )}

              {garagem > 0 && (
                <Col md={8} lg={6}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <AiFillCar /> Garagem: {garagem}
                  </div>
                </Col>
              )}

              {au && (
                <Col md={8} lg={6}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <BsArrowsMove /> Área: {au}
                  </div>
                </Col>
              )}
            </Row>

            <Divider style={{ padding: 2, marginTop: 5, marginBottom: 10 }} />

            {/* <Text type="secondary">{tipo.charAt(0).toUpperCase() + tipo.slice(1)}</Text> */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                maxWidth: 800
              }}
            >
              <div
                style={{ textAlign: 'justify', maxWidth: 1000 }}
              >
                <div style={{ width: '100%' }}>
                  <Title
                    level={isMobile ? 4 : 3}
                    style={{ marginBottom: 10, textAlign: 'left' }}
                  >
              Descrição
                  </Title>
                  {isHTML(descricaoCompleta)
                    ? (
                      <div
                        className="ql-editor quill-content"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(descricaoCompleta)
                        }}
                        style={{ lineHeight: 1.7 }}
                      />
                    )
                    : (
                      <Text>
                        {descricaoCompleta &&
                        descricaoCompleta[0].toUpperCase() +
                          descricaoCompleta.slice(1)}
                      </Text>
                    )}
                </div>
              </div>
            </div>

            <div style={{ marginTop: 10 }}>
              <Title
                level={isMobile ? 4 : 3}
                style={{ marginBottom: 20, textAlign: 'center' }}
              >
              Valor do imóvel: {Number(valor.replace('R$', '')).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL'
                })}
              </Title>
            </div>

            {features && features.length > 0 && (
              <div>
                <Divider style={{ marginTop: 20, marginBottom: 10 }} />
                <Title
                  level={isMobile ? 4 : 3}
                  style={{ marginBottom: 20, textAlign: 'left' }}
                >
                  Características do imóvel
                </Title>
              </div>
            )}
            <Row gutter={[16, 12]} style={{ marginTop: 10, paddingLeft: 10 }}>
              {features.map((feature) => (
                <Col key={feature.id} xs={24} sm={12} md={8} lg={8}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 8
                    }}
                  >
                    <FaCheckCircle style={{ color: '#52c41a', marginTop: 4 }} />
                    <Text>{feature.name}</Text>
                  </div>
                </Col>
              ))}
            </Row>
            <Divider />

            <Space direction="vertical" style={{ width: '100%' }}>
              <Title level={isMobile ? 4 : 3}>Compartilhe em suas redes sociais:</Title>
            </Space>

            <div
              style={{
                marginTop: 20,
                flexWrap: 'wrap',
                display: 'flex',
                gap: 10,
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Button
                icon={<FaWhatsapp />}
                onClick={() => window.open(shareLinks.whatsapp)}
              >
                WhatsApp
              </Button>
              <Button
                icon={<FaTelegram />}
                onClick={() => window.open(shareLinks.telegram)}
              >
                Telegram
              </Button>
              <Button
                icon={<FaFacebook />}
                onClick={() => window.open(shareLinks.facebook)}
              >
                Facebook
              </Button>
              <Button icon={<FaCopy />} onClick={handleCopyLink}>
                Copiar link
              </Button>
            </div>
            <div style={{ marginTop: 20 }}>
              <Button
                type="primary"
                size="large"
                onClick={() => window.open(whats)}
              >
                Fale conosco via WhatsApp
              </Button>
            </div>
          </div>
          <RelatedProducts codigo={productCode} />
        </Row>
      </div>
      <Footer />
    </>
  )
}
